import store from '@/store';

let indexMethod=(index,pageNo,pageSize)=>{
  // 表格序号、排名
  let x = pageNo - 1
  return pageSize * x + index + 1;
}

let fullTime = value => {
    //时间转换（格式：2019-04-17 15:28:48）
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}

let fullTimeData = value => {
  //时间转换（格式：2019-04-17 15:28:48）
  let date = new Date(value);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  return y + '-' + MM;
}

let fullTimeShort = value => {
  //时间转换（格式：2019-04-17）
  let date = new Date(value);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  return y + '-' + MM + '-' + d;
}

let yearMonthDayTime = value => {
    //时间转换（格式：2019-04-17）
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + MM + '-' + d;
}
let yearMonthDayTime2 = value => {
    //时间转换（格式：2019-04-17）未乘1000
    let date = new Date(value * 1000);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + MM + '-' + d;
}
let getWeek=value=>{
    //时间转换（格式：星期一）
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let week=new Date(y + '-' + MM + '-' + d).getDay();
    var weekDay = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
    return weekDay[week]
}
let getLastDay = value => {
    //返回日期(日)（格式：17）
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return d;
}
export let platformEng=value=>{
  //中文平台转换
  let platformCe = '';
  let e = value;
  let f = [
    {
      name: '淘宝网',
      platform: 'TB',
    },{
      name: '淘宝',
      platform: 'TB',
    },{
      name: 'TB',
      platform: 'TB',
    },{
      name: '天猫商城',
      platform: 'TM',
    },{
      name: '天猫',
      platform: 'TM',
    },{
      name: 'TM',
      platform: 'TM',
    },{
      name: '京东商城',
      platform: 'JD',
    },{
      name: '京东',
      platform: 'JD',
    },{
      name: 'JD',
      platform: 'JD',
    },{
      name: '苏宁易购',
      platform: 'SN',
    },{
      name: '苏宁',
      platform: 'SN',
    },{
      name: 'SN',
      platform: 'SN',
    },{
      name: '国美在线',
      platform: 'GM',
    },{
      name: '拼多多',
      platform: 'PDD',
    },{
      name: 'PDD',
      platform: 'PDD',
    },{
      name: '亚马逊',
      platform: 'AMAZON',
    },{
      name: '唯品会',
      platform: 'WPH',
    },{
      name: '药房网',
      platform: 'YFW',
    },{
      name: '1药城',
      platform: 'YYC',
    },{
      name: '1688',
      platform: '1688',
    },{
      name: '速卖通',
      platform: 'SMT',
    },{
      name: '其他',
      platform: 'platform_OTHER',
    },{
      name: '当当网',
      platform: 'DD',
    },{
      name: '当当',
      platform: 'DD',
    },{
      name: 'DD',
      platform: 'DD',
    },{
      name: '闲鱼',
      platform: 'XY',
    },{
      name: '阿里零售通',
      platform: 'ALST',
    },{
      name: '1号店',
      platform: '1HD',
    },{
      name: '云集',
      platform: 'YJWD',
    },{
      name: '邮乐网',
      platform: 'YLW',
    },{
      name: '微信',
      platform: 'WECD',
    },{
      name: '蘑菇街',
      platform: 'MGJ',
    },{
      name: '聚美优品',
      platform: 'JMYP',
    },{
      name: '楚楚街',
      platform: 'CCJ',
    },{
      name: '贝贝网',
      platform: 'BBWG',
    },{
      name: 'lazada-越南',
      platform: 'LZDVN',
    },{
      name: 'lazada-新加坡',
      platform: 'LZDSG',
    },{
      name: 'lazada-马来西亚',
      platform: 'LZDMY',
    },{
      name: '美团',
      platform: 'MT',
    }
  ];
  for (let i = 0; i < f.length; i++) {
     if (e == f[i].name) {
       platformCe = f[i].platform
     }
  }
  return platformCe;
}
let platformChinese = value => {
  //中文平台转换
  let platformCe = '';
  let e = value;
  let f = [
    {
      name: '淘宝天猫',
      platform: 'AL',
    },{
      name: '淘宝网',
      platform: 'TB',
    },{
      name: '天猫商城',
      platform: 'TM',
    },{
      name: '京东商城',
      platform: 'JD',
    },{
      name: '苏宁易购',
      platform: 'SN',
    },{
      name: '国美在线',
      platform: 'GM',
    },{
      name: '拼多多',
      platform: 'PDD',
    },{
      name: '亚马逊',
      platform: 'AMAZON',
    },{
      name: '唯品会',
      platform: 'WPH',
    },{
      name: '1688',
      platform: '1688',
    },{
      name: '速卖通',
      platform: 'SMT',
    },{
      name: '其他',
      platform: 'platform_OTHER',
    },{
      name: '当当网',
      platform: 'DD',
    },{
      name: '闲鱼',
      platform: 'XY',
    },{
      name: '阿里零售通',
      platform: 'ALST',
    },{
      name: '1号店',
      platform: '1HD',
    },{
      name: '云集',
      platform: 'YJWD',
    },{
      name: '邮乐网',
      platform: 'YLW',
    },{
      name: '微信',
      platform: 'WECD',
    },{
      name: '蘑菇街',
      platform: 'MGJ',
    },{
      name: '聚美优品',
      platform: 'JMYP',
    },{
      name: '楚楚街',
      platform: 'CCJ',
    },{
      name: '贝贝网',
      platform: 'BBWG',
    },
    {
      name: '淘宝天猫',
      platform: 'TBTM'
    },
    {
      name: '药房网',
      platform: 'YFW'
    },
    {
      name: '1药城',
      platform: 'YYC',
    },
    {
      name: '唯品会',
      platform: 'WPH'
    },
    {
      name: '总趋势',
      platform: 'ALL'
    },
    {
      name: 'lazada-越南',
      platform: 'LZDVN',
    },
    {
      name: 'lazada-新加坡',
      platform: 'LZDSG',
    },
    {
      name: 'lazada-马来西亚',
      platform: 'LZDMY',
    },{
      name: '美团',
      platform: 'MT',
    }

  ];
  for (let i = 0; i < f.length; i++) {
     if (e == f[i].platform) {
       platformCe = f[i].name
     }
  }
  return platformCe;
}
export let platformChineseFun=value=>{
  return platformChinese(value)
}
let getStatusNme=(status,logintype,other)=>{
  if(!String(status)){
    return ''
  }
  let kefuStatus=[
    {kefuName:"待初审",shopName:'初审中',other:'初审中',myReport:'初审中',status:'0'},
    {kefuName:"待店铺响应",shopName:'待我响应',other:'待我响应',myReport:' 待店铺响应',status:'1'},
    {kefuName:"店铺已整改-待复查",shopName:'我已整改-待复查',other:'处理中',myReport:'店铺已整改-复查中',status:'2'},
    {kefuName:"店铺整改合格-待处理",shopName:'整改合格-待处理',other:'处理中',myReport:'店铺整改合格-处理中',status:'3'},
    {kefuName:"店铺整改不合格-待处理",shopName:'整改不合格-待处理',other:'处理中',myReport:' 店铺整改不合格-处理中',status:'4'},
    {kefuName:"店铺已申诉-待评定",shopName:'我已申诉-待评定',other:'处理中',myReport:' 店铺已申诉-评定中',status:'5'},
    {kefuName:"店铺未响应-待处理",shopName:'我未响应-待处理',other:'处理中',myReport:'店铺未响应-处理中',status:'6'},
    {kefuName:"已结案",shopName:'已结案',other:'已结案',myReport:'已结案',status:'7'},
    {kefuName:"二次申诉待处理",shopName:'二次申诉待处理',other:'处理中',myReport:'二次申诉处理中',status:'8'},
    {kefuName:"已结案",shopName:'已结案',other:'已结案',myReport:'已结案',status:'9'},
    {kefuName:"异常举报",shopName:'异常举报',other:'异常举报',myReport:'异常举报',status:'10'},
    {kefuName:"待处理",shopName:'已结案',other:'已结案',myReport:'处理中',status:'11'},
    {kefuName:"已处理",shopName:'已处理',other:'已处理',myReport:'已处理',status:'12'},
    {kefuName:"待店铺响应",shopName:'待我响应',other:'待我响应',myReport:' 待店铺响应',status:'13'},
  ]
  let result
  kefuStatus.map(item=>{
    if(item.status==status){
      result=item
    }
  })

  if(!logintype)logintype=JSON.parse(localStorage.getItem('userData')).logintype
  if(!other){
    //默认取
    if(logintype==='HCM'||logintype==='HCMSUB'||logintype==='KEFU'){
      return result?result.kefuName:''
    }else{
      return result?result.shopName:''
    }

  }else{
    //取相对应的字段
    return result?result[other]:''
  }

}
let flowListName=(status)=>{
  let arr=[
    {info:'店铺响应整改',status:2},
    {info:'审核举报信息，审核结果为通过',status:1},
    {info:'复查整改情况，复查结果为合格',status:3},
    {info:'复查整改情况，复查结果为不合格',status:4},
    {info:'店铺提交申诉',status:5},
    {info:'店铺未响应',status:6},
    {info:'店铺提交二次申诉',status:8},
    {info:'审核举报信息，审核结果为驳回',status:10},
    {info:'评定申诉内容，评定结果为不合理',status:13},
    {info:'评定申诉内容，评定结果为合理',status:14},
  ]
  let result
  arr.map(item=>{
   if(item.status==status){
     result=item.info
   }
  })
  return result
}
export default {
    indexMethod,
    fullTime,
    fullTimeShort,
    fullTimeData,
    yearMonthDayTime,
    yearMonthDayTime2,
    getWeek,
    getLastDay,
    platformChinese,
    getStatusNme,
    flowListName
}
